<script setup lang="ts">
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { PaginationPrev, type PaginationPrevProps } from "reka-ui";
import { computed, type HTMLAttributes } from "vue";

const props = withDefaults(
    defineProps<PaginationPrevProps & { class?: HTMLAttributes["class"] }>(),
    {
        asChild: true,
    },
);

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});
</script>

<template>
    <PaginationPrev v-bind="delegatedProps">
        <Button
            :class="
                cn('h-10 w-10 justify-start bg-transparent p-0 ', props.class)
            "
            variant="ghost"
        >
            <slot>
                <SvgArrowBack24 class="!h-6 !w-6" />
            </slot>
        </Button>
    </PaginationPrev>
</template>
